export default __webpack_public_path__ + "static/crab-cdc17642103315787405a51556252997.svg";